module.exports = __webpack_public_path__ + "img/0fe74f7.jpg";